<template>
  <div>
    <div style="background-color: white;overflow:hidden;">
      <div>
        <h1 class="g-hd">
          药品退货单
        </h1>
        <div style="background-color: white">
          <van-search style="height:100%;float: right;width: 100%" v-model="searchValue" @input="onInput(searchValue)" placeholder="请输入搜索关键词"/>
        </div>
      </div>
    </div>
    <div class="clear">
      <van-tabs tabs-default-color="blue" @click="onClick" color="#429EF5">
        <van-tab title="待提交">
          <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh(0)">
            <orderItems ref="orderItems" :flag="waitSure" :searchValue="searchValue"></orderItems>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="全部">
          <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh(1)">
            <orderItemsAll ref="orderItemsAll" :flag="all" :searchValue="searchValue"></orderItemsAll>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import api from "@/axios/api";
import {mapGetters, mapActions} from "vuex";
import orderItems from './orderItems';
import orderItemsAll from './orderItems';
import {Notify} from 'vant';
import {Toast} from 'vant';

export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        if (val) {

        }
      }
    }
  },
  mounted() {

  },
  components: {
    orderItems,orderItemsAll
  },
  data() {
    return {
      value: '',
      list: [],
      loading: false,
      finished: false,
      count: 0,
      sendFlag:0,
      isLoading: false,
      activeName:'',
      waitSure:"wait",
      all:"all",
      searchValue:''
    };
  },
  methods: {
    onRefresh(value) {
      if (value===0){
        setTimeout(() => {
          //清空列表数据
          this.$refs.orderItems.orderReturnList = [];
          this.$refs.orderItems.getOrderReturnItems(this.searchValue);
          this.isLoading = false;
          this.count++;
        }, 1000);
      }else {
        setTimeout(() => {
          //清空列表数据
          this.$refs.orderItemsAll.orderReturnList = [];
          this.$refs.orderItemsAll.getOrderReturnItems(this.searchValue);
          this.isLoading = false;
          this.count++;
        }, 1000);
      }

    },
    onInput(searchValue){
      this.$refs.orderItems.getOrderReturnItems(searchValue);
      if (this.sendFlag>0){
        this.$refs.orderItemsAll.getOrderReturnItems(searchValue);
      }
    },
    onClick(name,title){
      // Toast(name+","+title);
      if (name === 0){
        this.$refs.orderItems.localFlag = this.waitSure;
        this.$refs.orderItems.getOrderReturnItems(this.searchValue);
      }else {
        if (this.sendFlag>0){
          this.$refs.orderItemsAll.localFlag = this.all;
          this.$refs.orderItemsAll.getOrderReturnItems(this.searchValue);
        }
        this.sendFlag++;
      }

    }
  }
}
</script>

<style scoped>
.clear {
  clear: both;
}

.g-hd {
  display: inline;
  float: left;
  font-size: 20px;
  font-weight: bolder;
  font-style: normal;
  color: #2c2c2c;
  background-color: white;
  margin-left: 3%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/spd/orderReturnList.vue